"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputStyleChecked = exports.inputStyle = exports.radioInputNoOutline = exports.radioInputLabelError = exports.inputGroupBlock = exports.inputGroup = exports.radioInputButton = exports.radioInputItem = exports.radioInputLabel = void 0;

var _stylitas = require("@creditas/stylitas");

const radioInputButton = ({
  theme,
  checked
}) => {
  const borderColor = checked ? theme.bColorsecondary05 : theme.bColorneutral03;
  return (0, _stylitas.css)`
    align-items: center;
    justify-content: center;
    background-color: transparent;
    height: 1.5rem;
    width: 1.5rem;
    border: 1px solid ${borderColor};
    border-radius: 50%;
    margin-right: 0.5rem;
    vertical-align: bottom;

    ${(0, _stylitas.mq)({
    display: ['flex', 'flex', 'flex', undefined, undefined, undefined]
  })}
  `;
};

exports.radioInputButton = radioInputButton;

const radioInputNoOutline = () => (0, _stylitas.css)`
  outline: none;
`;

exports.radioInputNoOutline = radioInputNoOutline;

const radioInputItem = ({
  fullWidth
}) => {
  const width = fullWidth ? '100%' : 'auto';
  return (0, _stylitas.css)`
    display: flex;
    align-items: center;
    height: auto;
    width: ${width};
  `;
};

exports.radioInputItem = radioInputItem;

const inputStyleChecked = ({
  theme
}) => (0, _stylitas.css)`
  &:checked + label {
    border-color: ${theme.bColorsecondary05};
    background-color: ${theme.bColorsecondary01};
  }

  &:checked + label > div > span:before {
    content: '';
    display: block;
    background-color: ${theme.bColorsecondary04};
    border-color: ${theme.bColorsecondary05};
    height: 1rem;
    width: 1rem;
    border-radius: 50%;
  }
`;

exports.inputStyleChecked = inputStyleChecked;

const inputStyle = ({
  theme
}) => (0, _stylitas.css)`
  width: 0px;
  position: absolute;
  opacity: 0;

  span {
    border-color: ${theme.bColorsecondary05};
  }
`;

exports.inputStyle = inputStyle;

const radioInputLabelError = ({
  theme,
  error
}) => error && (0, _stylitas.css)`
    border-color: ${theme.bColordanger};
  `;

exports.radioInputLabelError = radioInputLabelError;

const radioInputLabel = ({
  theme,
  fullWidth
}) => {
  const labelWidth = fullWidth ? '100%' : 'auto';
  const labelStart = fullWidth ? 'flex-start' : 'center';
  const labelMargin = fullWidth ? '4px 0' : '0 4px 0 0';
  return (0, _stylitas.css)`
    display: flex;
    align-items: center;
    background-color: ${theme.bColorneutral01};
    border-radius: 3px;
    border: 1px solid ${theme.bColorneutral03};
    color: ${theme.bColorneutral07};
    font-size: 16px;
    font-weight: 300;
    cursor: pointer;

    ${(0, _stylitas.mq)({
    margin: ['4px 0', '4px 0', '4px 0', labelMargin, labelMargin, labelMargin],
    width: ['100%', '100%', '100%', labelWidth, labelWidth, labelWidth]
  })}

    div {
      width: 100%;
      display: flex;
      align-items: center;
      ${(0, _stylitas.mq)({
    justifyContent: ['flex-start', 'flex-start', 'flex-start', labelStart, labelStart, labelStart]
  })}
    }

    &:hover {
      border-color: ${theme.bColorsecondary05};
      background-color: ${theme.bColorneutral01};
      box-shadow: 0 10px 25px 0 ${theme.bColorneutral03};
    }

    ${(0, _stylitas.mq)({
    padding: ['0.95rem 1rem', '0.95rem 1rem', '0.95rem 1rem', '1rem', '1rem', '1rem'],
    textAlign: [undefined, undefined, undefined, 'center', 'center', 'center']
  })}
  `;
};

exports.radioInputLabel = radioInputLabel;

const inputGroup = () => (0, _stylitas.css)`
  flex-wrap: wrap;
  flex-direction: row;

  ${(0, _stylitas.mq)({
  justifyContent: [undefined, undefined, undefined, 'flex-start', 'flex-start', 'flex-start'],
  display: ['block', 'block', 'block', 'flex', 'flex', 'flex']
})}
`;

exports.inputGroup = inputGroup;

const inputGroupBlock = () => (0, _stylitas.css)`
  display: block;
`;

exports.inputGroupBlock = inputGroupBlock;